// biome-ignore lint: disable
import * as React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import type { WrapPageElementBrowserArgs } from 'gatsby';
import { theme } from '../theme';
import { Fonts } from '../theme/global';
import { Layout } from './Layout';

export const wrapPageElement = ({ element }: WrapPageElementBrowserArgs) => {
  return (
    <ChakraProvider theme={theme} resetCSS>
      <Fonts />
      <Layout>{element}</Layout>
    </ChakraProvider>
  );
};
